import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Home from "@/pages/Home";
import KnowledgeHub from "@/pages/KnowledgeHub";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import { LanguageProvider } from "@/context/LanguageContext";
import "@/App.css";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Chrome() {
  const { pathname } = useLocation();
  const hideNav = pathname === "/login" || pathname === "/admin";
  return !hideNav ? <Nav /> : null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollManager />
          <Chrome />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/knowledge" element={<KnowledgeHub />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "JetBrains Mono, monospace", fontSize: "12px" } }} />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
